import type { ChangeEvent } from 'react';
import { cn, FormatUtils } from '@shared/utils';
import { Button, Preloader } from '@shared/widgets';
import visa from '../visa.svg?url';

interface FormProps {
  loading: boolean;
  cardNumber: string;
  amount: string;
  currency: string;
  finalAmount: string;
  finalFee: string;
  onPost: () => void;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const Form = (props: FormProps) => {
  return (
    <div
      className={cn(
        'flex flex-col items-center gap-[56px] opacity-100 transition-opacity duration-300',
        props.loading && 'pointer-events-none opacity-40',
      )}
    >
      {props.loading ? <Preloader preloaderOpacity={0.95} top /> : null}
      <div className='flex w-[535px] flex-col items-stretch gap-9'>
        <div className='flex w-full flex-col items-start gap-[10px]'>
          <label htmlFor='To' className='text-left text-xl font-medium text-[#888]'>
            To
          </label>
          <span className='flex h-[90px] w-full items-center justify-between rounded-[10px] border-none bg-[#f3f4f4] px-7.5 text-left text-5xl text-[26px] font-semibold text-[#000]'>
            <img className='h-[36px] w-[50px] rounded bg-[#fff] shadow-md' src={visa} alt='visa' />
            {props.cardNumber}
          </span>
        </div>
        <div className='flex w-full flex-col items-start gap-[10px]'>
          <label htmlFor='Amount' className='text-left text-xl font-medium text-[#888]'>
            Amount
          </label>
          <div className='relative'>
            <input
              id='Amount'
              className='h-[90px] w-full rounded-[10px] border-none bg-[#f3f4f4] px-7.5 text-center text-5xl font-semibold'
              autoFocus
              required
              value={props.amount}
              onChange={props.onChange}
            />
            <div className='pointer-events-none absolute top-0 left-0 flex h-full w-full items-center justify-center'>
              <div className='relative text-5xl leading-[48px] font-semibold text-transparent'>
                <div className='absolute top-0 right-[100%] flex h-full items-center text-[#c6c7c8]'>{props.currency}</div>
                {props.amount}
              </div>
            </div>
          </div>
        </div>
        <div
          className={cn(
            'pointer-events-none flex flex-col justify-center gap-2 text-[20px] font-medium text-[#666] opacity-0 transition-opacity duration-300',
            props.finalAmount && 'opacity pointer-events-auto',
          )}
        >
          <div className='add-money__summary-row'>
            <span className='add-money__summary-key'>
              Fee {props.currency}
              {FormatUtils.formatMoney(+props.finalFee)}
            </span>
          </div>
          <div className='add-money__summary-row'>
            <span className='add-money__summary-key'>Final amount</span>
            <span className='font-bold text-[#000]'>
              {' '}
              {props.currency}
              {FormatUtils.formatMoney(+props.finalAmount)}
            </span>
          </div>
        </div>
      </div>
      <div className='flex w-full items-stretch justify-center'>
        <Button className='!h-auto w-[75%] !p-6' onClick={props.onPost}>
          Next
        </Button>
      </div>
    </div>
  );
};
